import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import { DefaultResponseWithData } from "../models/system";

export interface ICodSignatureStatus {
  applySignature: boolean;
  signatureUploaded: boolean;
  signatureBase64: string | null;
}

interface ICodSignatureStatusResponse
  extends DefaultResponseWithData<ICodSignatureStatus> {}

export default function useCodSignature() {
  const { get, put, del, postDocs } = useApiHelper();
  const queryClient = useQueryClient();

  const statusQuery = useQuery({
    queryKey: ["codSignature"],
    queryFn: () => get<ICodSignatureStatusResponse>("/cod/signature"),
  });

  const upload = useMutation(
    (data: FormData) => postDocs("/cod/signature", data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["codSignature"]);
      },
    }
  );

  const setApplySignature = useMutation(
    (applySignature: boolean) =>
      put("/cod/signature/config", { applySignature }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["codSignature"]);
      },
    }
  );

  const remove = useMutation(() => del("/cod/signature"), {
    onSuccess: () => {
      queryClient.invalidateQueries(["codSignature"]);
    },
  });

  return {
    status: statusQuery.data?.data,
    loading: statusQuery.isLoading,
    upload,
    setApplySignature,
    remove,
  };
}
